var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcDangerous = function SvgIcDangerous(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    fill: "none",
    viewBox: "0 0 41 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DB0B24",
    d: "M28.789 0H12.21L.5 11.711V28.29L12.211 40H28.79L40.5 28.289V11.71zm2.822 28.311-2.8 2.8L20.5 22.8l-8.311 8.311-2.8-2.8L17.7 20l-8.311-8.311 2.8-2.8L20.5 17.2l8.311-8.311 2.8 2.8L23.3 20z"
  })));
};
export default SvgIcDangerous;